export const languageList: Record<string, { name: string; short: string }> = {
  /**
   * YoloGames uses IETF as the primary standard for localization config.
   * In situations such as Portuguese, Chinese, English where there is more than one dialect, refer to secondary standard.
   * Primary: @see https://en.wikipedia.org/wiki/IETF_language_tag
   * Secondary: @see https://sbarnea.com/articles/simplified-locale-codes/
   *
   * Languages are displayed in the UI selector in the same order used in this file.
   * Refer to https://www.figma.com/file/Q9DL9biOlUeOvme4JdDoSg/branch/DlxwwT3Uc790d3jYxvqW01/Working-Draft?node-id=17606%3A441947&t=LO5Ko9X2DDP34v4T-0
   */
  en: {
    name: "English",
    short: "EN",
  },
  fr: {
    name: "Français",
    short: "FR",
  },
  es: {
    name: "Español",
    short: "ES",
  },
  de: {
    name: "Deutsch",
    short: "DE",
  },
  tr: {
    name: "Türkçe",
    short: "TR",
  },
  ru: {
    name: "Русский",
    short: "RU",
  },
  id: {
    name: "Bahasa Indonesia",
    short: "ID",
  },
  vi: {
    name: "Tiếng Việt",
    short: "VI",
  },
  th: {
    name: "ภาษาไทย",
    short: "TH",
  },
  "zh-Hans": {
    name: "简体中文",
    short: "简体中文",
  },
  "zh-Hant": {
    name: "繁體中文",
    short: "繁體中文",
  },
  ja: {
    name: "日本語",
    short: "日本",
  },
  ko: {
    name: "한국어",
    short: "한국어",
  },
  pt: {
    name: "Português",
    short: "pt",
  },
};
